import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MainButton } from 'elements/button/MainButton';
import { EFonts } from 'libs/styles/styling';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import { EWorldColor } from 'static/config/worldVariables';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const DetailBookingFull = (props: Props) => {
    const ctxModal = useContext(CtxModal);

    return (
        <S_DetailBookingFull className={props.className}>
            <S_IconContainer>
                <S_Icon icon={['fas', 'triangle-exclamation']} />
                <S_Title>{Localization.BOOKING_FULL_TITLE}</S_Title>
            </S_IconContainer>
            <S_Text>{Localization.BOOKING_FULL_MESSAGE}</S_Text>

            <S_SubmitButton
                type={'primary'}
                alignText="center"
                onClick={() => {
                    ctxModal.closeAll();
                }}
            >
                {Localization.BOOKING_SEE_OTHER_STANDS}
            </S_SubmitButton>
        </S_DetailBookingFull>
    );
};

const S_DetailBookingFull = styled.div``;

const S_Text = styled.div`
    margin-bottom: 25px;
    font-family: ${EFonts.Regular};
    line-height: 1.4em;
`;

const S_SubmitButton = styled(MainButton)`
    height: 40px;
    width: 200px;
    margin: 10px auto;
`;

const S_IconContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 60px;
    color: #${EWorldColor.YELLOW};
    margin-bottom: 20px;
`;

const S_Title = styled.div`
    font-family: ${EFonts.Bold};
    text-align: center;
    margin-bottom: 20px;
`;
